export function minutesAgo(minutes: number) {
  return new Date(Date.now() - 1000 * 60 * minutes);
}